import globalAxios from 'axios';
import { B as BaseAPI, D as DUMMY_BASE_URL, s as setBearerAuthToObject, b as setSearchParams, c as serializeDataIfNeeded, t as toPathString, o as operationServerMap, d as createRequestFunction, e as BASE_PATH } from '../common-BuhUSHAi.js';

/* tslint:disable */
/* eslint-disable */
/**
 * BizWeb Api
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * CategoryAttributesMapApi - axios parameter creator
 * @export
 */
const CategoryAttributesMapApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @summary  (Auth roles: Catalog)
         * @param {number} [cid]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteByCategory: async (cid, options = {}) => {
            const localVarPath = `/v1/CategoryAttributesMap/DeleteByCategory`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (cid !== undefined) {
                localVarQueryParameter['cid'] = cid;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary  (Auth roles: Catalog)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAttributes: async (options = {}) => {
            const localVarPath = `/v1/CategoryAttributesMap/GetAttributes`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary  (Auth roles: Catalog)
         * @param {number} [cid]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAttributesAssigned: async (cid, options = {}) => {
            const localVarPath = `/v1/CategoryAttributesMap/GetAttributesAssigned`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (cid !== undefined) {
                localVarQueryParameter['cid'] = cid;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary  (Auth roles: Catalog)
         * @param {number} [cid]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAttributesAvailable: async (cid, options = {}) => {
            const localVarPath = `/v1/CategoryAttributesMap/GetAttributesAvailable`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (cid !== undefined) {
                localVarQueryParameter['cid'] = cid;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary  (Auth roles: Catalog)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCategories: async (options = {}) => {
            const localVarPath = `/v1/CategoryAttributesMap/GetCategories`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary  (Auth roles: Catalog)
         * @param {CategoryAttributesMapToken} [CategoryAttributesMapToken]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        insert: async (CategoryAttributesMapToken, options = {}) => {
            const localVarPath = `/v1/CategoryAttributesMap/Insert`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(CategoryAttributesMapToken, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary  (Auth roles: Catalog)
         * @param {number} [id]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        remove: async (id, options = {}) => {
            const localVarPath = `/v1/CategoryAttributesMap/Delete`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (id !== undefined) {
                localVarQueryParameter['id'] = id;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary  (Auth roles: Catalog)
         * @param {CategoryAttributesMapTokenArgs} [CategoryAttributesMapTokenArgs]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        save: async (CategoryAttributesMapTokenArgs, options = {}) => {
            const localVarPath = `/v1/CategoryAttributesMap/Save`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(CategoryAttributesMapTokenArgs, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary  (Auth roles: Catalog)
         * @param {CategoryAttributesMapToken} [CategoryAttributesMapToken]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        update: async (CategoryAttributesMapToken, options = {}) => {
            const localVarPath = `/v1/CategoryAttributesMap/Update`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(CategoryAttributesMapToken, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * CategoryAttributesMapApi - functional programming interface
 * @export
 */
const CategoryAttributesMapApiFp = function (configuration) {
    const localVarAxiosParamCreator = CategoryAttributesMapApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @summary  (Auth roles: Catalog)
         * @param {number} [cid]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteByCategory(cid, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteByCategory(cid, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CategoryAttributesMapApi.deleteByCategory']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary  (Auth roles: Catalog)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAttributes(options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAttributes(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CategoryAttributesMapApi.getAttributes']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary  (Auth roles: Catalog)
         * @param {number} [cid]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAttributesAssigned(cid, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAttributesAssigned(cid, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CategoryAttributesMapApi.getAttributesAssigned']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary  (Auth roles: Catalog)
         * @param {number} [cid]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAttributesAvailable(cid, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAttributesAvailable(cid, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CategoryAttributesMapApi.getAttributesAvailable']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary  (Auth roles: Catalog)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCategories(options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCategories(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CategoryAttributesMapApi.getCategories']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary  (Auth roles: Catalog)
         * @param {CategoryAttributesMapToken} [CategoryAttributesMapToken]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async insert(CategoryAttributesMapToken, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.insert(CategoryAttributesMapToken, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CategoryAttributesMapApi.insert']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary  (Auth roles: Catalog)
         * @param {number} [id]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async remove(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.remove(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CategoryAttributesMapApi.remove']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary  (Auth roles: Catalog)
         * @param {CategoryAttributesMapTokenArgs} [CategoryAttributesMapTokenArgs]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async save(CategoryAttributesMapTokenArgs, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.save(CategoryAttributesMapTokenArgs, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CategoryAttributesMapApi.save']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary  (Auth roles: Catalog)
         * @param {CategoryAttributesMapToken} [CategoryAttributesMapToken]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async update(CategoryAttributesMapToken, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.update(CategoryAttributesMapToken, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CategoryAttributesMapApi.update']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    };
};
/**
 * CategoryAttributesMapApi - factory interface
 * @export
 */
const CategoryAttributesMapApiFactory = function (configuration, basePath, axios) {
    const localVarFp = CategoryAttributesMapApiFp(configuration);
    return {
        /**
         *
         * @summary  (Auth roles: Catalog)
         * @param {number} [cid]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteByCategory(cid, options) {
            return localVarFp.deleteByCategory(cid, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary  (Auth roles: Catalog)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAttributes(options) {
            return localVarFp.getAttributes(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary  (Auth roles: Catalog)
         * @param {number} [cid]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAttributesAssigned(cid, options) {
            return localVarFp.getAttributesAssigned(cid, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary  (Auth roles: Catalog)
         * @param {number} [cid]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAttributesAvailable(cid, options) {
            return localVarFp.getAttributesAvailable(cid, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary  (Auth roles: Catalog)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCategories(options) {
            return localVarFp.getCategories(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary  (Auth roles: Catalog)
         * @param {CategoryAttributesMapToken} [CategoryAttributesMapToken]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        insert(CategoryAttributesMapToken, options) {
            return localVarFp.insert(CategoryAttributesMapToken, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary  (Auth roles: Catalog)
         * @param {number} [id]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        remove(id, options) {
            return localVarFp.remove(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary  (Auth roles: Catalog)
         * @param {CategoryAttributesMapTokenArgs} [CategoryAttributesMapTokenArgs]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        save(CategoryAttributesMapTokenArgs, options) {
            return localVarFp.save(CategoryAttributesMapTokenArgs, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary  (Auth roles: Catalog)
         * @param {CategoryAttributesMapToken} [CategoryAttributesMapToken]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        update(CategoryAttributesMapToken, options) {
            return localVarFp.update(CategoryAttributesMapToken, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * CategoryAttributesMapApi - object-oriented interface
 * @export
 * @class CategoryAttributesMapApi
 * @extends {BaseAPI}
 */
class CategoryAttributesMapApi extends BaseAPI {
    /**
     *
     * @summary  (Auth roles: Catalog)
     * @param {number} [cid]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CategoryAttributesMapApi
     */
    deleteByCategory(cid, options) {
        return CategoryAttributesMapApiFp(this.configuration).deleteByCategory(cid, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary  (Auth roles: Catalog)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CategoryAttributesMapApi
     */
    getAttributes(options) {
        return CategoryAttributesMapApiFp(this.configuration).getAttributes(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary  (Auth roles: Catalog)
     * @param {number} [cid]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CategoryAttributesMapApi
     */
    getAttributesAssigned(cid, options) {
        return CategoryAttributesMapApiFp(this.configuration).getAttributesAssigned(cid, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary  (Auth roles: Catalog)
     * @param {number} [cid]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CategoryAttributesMapApi
     */
    getAttributesAvailable(cid, options) {
        return CategoryAttributesMapApiFp(this.configuration).getAttributesAvailable(cid, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary  (Auth roles: Catalog)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CategoryAttributesMapApi
     */
    getCategories(options) {
        return CategoryAttributesMapApiFp(this.configuration).getCategories(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary  (Auth roles: Catalog)
     * @param {CategoryAttributesMapToken} [CategoryAttributesMapToken]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CategoryAttributesMapApi
     */
    insert(CategoryAttributesMapToken, options) {
        return CategoryAttributesMapApiFp(this.configuration).insert(CategoryAttributesMapToken, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary  (Auth roles: Catalog)
     * @param {number} [id]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CategoryAttributesMapApi
     */
    remove(id, options) {
        return CategoryAttributesMapApiFp(this.configuration).remove(id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary  (Auth roles: Catalog)
     * @param {CategoryAttributesMapTokenArgs} [CategoryAttributesMapTokenArgs]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CategoryAttributesMapApi
     */
    save(CategoryAttributesMapTokenArgs, options) {
        return CategoryAttributesMapApiFp(this.configuration).save(CategoryAttributesMapTokenArgs, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary  (Auth roles: Catalog)
     * @param {CategoryAttributesMapToken} [CategoryAttributesMapToken]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CategoryAttributesMapApi
     */
    update(CategoryAttributesMapToken, options) {
        return CategoryAttributesMapApiFp(this.configuration).update(CategoryAttributesMapToken, options).then((request) => request(this.axios, this.basePath));
    }
}

export { CategoryAttributesMapApi, CategoryAttributesMapApiAxiosParamCreator, CategoryAttributesMapApiFactory, CategoryAttributesMapApiFp };
//# sourceMappingURL=category-attributes-map-api.js.map
